<template>
    <div id="company-list">
        <template v-if="isLoaded">
            <template v-if="companies.length > 0">
                <b-list-group>
                    <b-list-group-item v-for="company in companies" :key="company.id" :to="{ name: 'managerCompany', params: { id: company.id }}" exact>
                        <strong>{{ company.id }}</strong>
                    </b-list-group-item>
                </b-list-group>
            </template>
            <template v-else>
                <div class="alert alert-warning">
                    {{ $t("noRows") }}
                </div>
            </template>
            <hr>
            <form class="form-inline">
                <div class="form-group mr-3">
                    <input class="form-control" v-model="newCompanyId">
                </div>
                <button class="btn btn-primary" @click.prevent="addNewCompany" :disabled="newCompanyId.length <= 0">{{ $t("manager.companies.addNew") }}</button>
            </form>
        </template>
        <template v-else>
            <div class="text-center">
                <font-awesome-icon icon="spinner" pulse />
            </div>
        </template>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Companies',
  data () {
    return {
      isLoaded: false,
      newCompanyId: '',
      companies: []
    }
  },
  methods: {
    loadBackendIdList: function () {
      let me = this
      axios.get(me.$store.getters.urlPath + 'services/manager/getBackendIds.php')
        .then(function (response) {
          me.companies = response.data
          me.isLoaded = true
        })
        .catch(function (error) {
          // eslint-disable-next-line
          console.log(error)
        })
    },
    addNewCompany: function () {
      let me = this
      axios.put(me.$store.getters.urlPath + 'services/manager/createBackendId.php', {
        id: me.newCompanyId
      })
        .then((response) => {
          me.companies.push({ id: me.newCompanyId })
          me.newCompanyId = ''
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
        })
    }
  },
  mounted () {
    this.loadBackendIdList()
  }
}
</script>
